import styled from 'styled-components/macro';
import { ITEM_STATUS } from '../../../models/Completion';

const statusColours = {
  [ITEM_STATUS.notStarted]: { dot: '#8a8a8a', background: '#f0f0f0' },
  [ITEM_STATUS.inProgress]: { dot: '#e8930c', background: '#fff3df' },
  [ITEM_STATUS.complete]: { dot: '#2e9e5b', background: '#e3f5ea' },
};

export const StatusPill = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  gap: 0.5em;
  padding: 0.3em 0.8em;
  border-radius: 999px;
  font-size: 1.3rem;
  font-weight: 700;
  white-space: nowrap;
  color: ${({ theme }) => theme.headerColour};
  background: ${({ status }) => statusColours[status].background};
`;

export const StatusDot = styled.span`
  width: 1em;
  height: 1em;
  border-radius: 50%;
  background: ${({ status }) => statusColours[status].dot};
`;
